import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=22b99ff2"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b99ff2')) {
      api.createRecord('22b99ff2', component.options)
    } else {
      api.reload('22b99ff2', component.options)
    }
    module.hot.accept("./Basic.vue?vue&type=template&id=22b99ff2", function () {
      api.rerender('22b99ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/mailDriver/Basic.vue"
export default component.exports